// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogPostExcerpt_wrapper"};